const DataProvider = {
  mediumList: [
    { value: "English", label: "English" },
    { value: "Hindi", label: "Hindi" },
    { value: "Marathi", label: "Marathi" },
    { value: "Semi English", label: "Semi English" },
  ],
  questionType: [
    { value: "Question Bank", label: "Question Bank" },
    { value: "SAT Exam", label: "SAT Exam" },
  ],
  typeOfQuestion: [
    { value: "General", label: "General" },
    { value: "Comprehensive", label: "Comprehensive" },
    { value: "Poem", label: "Poem" },
  ],
  answerOptions: [
    { value: 0, label: "Option A" },
    { value: 1, label: "Option B" },
    { value: 2, label: "Option C" },
    { value: 3, label: "Option D" },
  ],
  standaredList: [
    { value: "12th Standard", label: "12th Standard" },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: "Post Graduation", label: "Post Graduation" },
  ],
  mode: [
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Upi", label: "Upi" },
  ],
  commissionEarned: [
    { value: 1, label: "Commission Earned" },
    { value: 2, label: "Amount Paid" },
  ],
  // roles: [
  //   { value: "Super Admin", label: "Super Admin" },
  //   { value: "Sub Admin", label: "Sub Admin" },
  //   { value: "Other", label: "Other" },
  // ],
  setPrivileges: [
    { value: "class master", label: "Class Master" },
    { value: "subject master", label: "Subject Master" },
    { value: "study material", label: "Study material" },
    { value: "question bank", label: "Question Bank" },
    { value: "blogs", label: "Blogs" },
    { value: "testimonials", label: "Testimonials" },
    { value: "mock test", label: "Mock Test" },
    { value: "faqs", label: "Faq's" },
    { value: "packages", label: "Packages" },
    { value: "bharatsatexam", label: "Bharat Sat Exam" },
    { value: "coordinator", label: "Coordinator" },
    { value: "student", label: "Students" },
    { value: "reports", label: "Reports" },
    { value: "dynamic", label: "Dynamic" },
    { value: "updateslider", label: "Updateslider" },
    { value: "statemaster", label: "State Master" },
    { value: "districtmaster", label: "District Master" },
    { value: "talukamaster", label: "Taluka Master" },
    { value: "pincodemaster", label: "Pincode Master" },
    { value: "reviewer", label: "Reviewer" },
    { value: "coupon", label: "Coupon" },
  ],
  registeredBy: [
    {
      value: "Student", label:"Student/Self"
    },
    {
      value: "Coordinator", label:"Coordinator"
    },
  ],
  Genders: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ],
  Rank: [
    { value: "first", label: "First" },
    { value: "second", label: "Second" },
    { value: "third", label: "Third" },
  ],
  Status: [
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Edited", label: "Edited" },
  ],
};

export default DataProvider;